"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CloseCircle["default"];
  }
});

var _CloseCircle = _interopRequireDefault(require("../lib/icons/legacy/CloseCircle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
